module.exports = __webpack_public_path__ + "img/gzjt2.a4af717b.jpg";